import type { ReactNode } from 'react';

/**
 * S-UI-002: Three animated CSS placeholder rows shown while the repo list loads.
 * Matches real RepoRow height to prevent layout shift.
 */
export function RepoListSkeleton(): ReactNode {
  return (
    <div className="repo-list-skeleton" aria-label="Loading repositories" aria-busy="true">
      {[1, 2, 3].map(i => (
        <div key={i} className="repo-row-skeleton" aria-hidden="true">
          <span className="repo-row-skeleton__star" />
          <span className="repo-row-skeleton__name" />
          <span className="repo-row-skeleton__meta" />
        </div>
      ))}
    </div>
  );
}
